import React from 'react'
import styled from 'styled-components'

import winItImage from '../../../public/static/images/png/winitMediumLogo.png'

const PoweredByWinItLogoMobile = styled.img`
  display: flex;
  flex-wrap: wrap;
  border-style: solid;
  border-width: 1px;
  padding: .375rem .6875rem .375rem .6875rem;
  border-radius: 2.5rem;
  border-color: ${props => props.theme.colors.text.inputPlaceholder}
`

const WinItMobileLogo = (props) => {
  return (
      <PoweredByWinItLogoMobile src={winItImage} />
  )
}

export default WinItMobileLogo